module.exports = __webpack_public_path__ + "img/profile.8a3619cc.svg";